import { TCalendarSummary } from "../interfaces/SalaryInterface";

export const SalaryPeriodicity = {
  MONTHLY: "monthly",
  YEARLY: "yearly"
} as const;

export const TaxOptedStatus = {
  SINGLE: "single",
  COUPLE: "couple"
} as const;

export const RetirementFundType = {
  CITIZEN_INVESTMENT_TRUST: "citizenInvestmentTrust",
  PROVIDENT_FUND: "providentFund",
  SOCIAL_SECURITY_FUND: "socialSecurityFund",
  NONE: "none"
} as const;

export const PayrollAttendanceSource = {
  SYSTEM: "system",
  CUSTOM: "custom"
} as const;

// types
export type TSalaryPeriodicity = (typeof SalaryPeriodicity)[keyof typeof SalaryPeriodicity];
export type TTaxOptedStatus = (typeof TaxOptedStatus)[keyof typeof TaxOptedStatus];
export type TRetirementFundType = (typeof RetirementFundType)[keyof typeof RetirementFundType];
export type TPayrollAttendanceSource =
  (typeof PayrollAttendanceSource)[keyof typeof PayrollAttendanceSource];

export const calendarSummaryExtraData: {
  [K in keyof TCalendarSummary]: {
    label: string;
    info: string;
    required: boolean;
  };
} = {
  calendarDays: {
    label: "Calendar Days",
    info: "Total days in the month. Count all attendance dates.",
    required: true
  },

  employmentDays: {
    label: "Employment Days",
    info: "Days employed in the current month. Count days from joining date through month-end.",
    required: false
  },

  defaultWeeklyOffs: {
    label: "Default Weekly Offs",
    info: "Weekly offs entitled to the employee. Count weekly-off dates after joining.",
    required: true
  },

  publicHolidays: {
    label: "Public Holidays",
    info: "Public holidays in the month. Count holidays after joining.",
    required: false
  },

  unpaidLeaveDays: {
    label: "Unpaid Leave Days",
    info: "Unpaid leave days in the month. Count unpaid leaves and absences..",
    required: false
  },

  businessDays: {
    label: "Business Days",
    info: "Days the office is open. Calculation: Employment Days − Weekly Offs − Public Holidays.",
    required: true
  },

  payableDays: {
    label: "Payable Days",
    info: "Days payable for the month. Calculate: Employment Days − Unpaid Leave Days.",
    required: true
  }
};
